import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="wrap site-footer__inner">
        <p>{t('copyright')}</p>
        <p>{t('footerDescription')}</p>
      </div>
    </footer>
  );
};

export default Footer;
